import React from 'react';
import { Link } from 'react-router-dom';
import { strings } from '/imports/strings';
import { Icon } from '/imports/ui/Icon';
import { useFind, useSubscribed, useUser } from '/imports/hooks';
import { Publications } from '/imports/publications';
import { MessageReceipts } from '/imports/api/messages';

const linkClassName = 'relative inline-flex flex-col items-center justify-center text-center text-[0.8rem] text-fg-1 no-underline [&_i]:flex [&_i]:justify-center';
const badgeClassName = 'badge absolute top-0 right-0 flex h-4 flex-col justify-around rounded-xl bg-primary px-[0.4rem] py-[0.2rem] text-center text-[0.8rem] font-bold text-on-primary';

export const FooterNav = () => {
  const user = useUser();
  const userId = user?._id;
  const orgId = user?.orgId;
  const loadingUnreads = useSubscribed(Publications.unreadMessageReceipts);
  const unreads = useFind(() => MessageReceipts.find({ userId }), [orgId, loadingUnreads]);
  const numUnread = unreads.length;
  return (
    <div className="relative mt-auto flex h-footer-nav justify-between border-t-2 border-mid bg-panel px-4 py-2 [&_[icon=warning]]:absolute [&_[icon=warning]]:top-0 [&_[icon=warning]]:right-0">
      <Link className={linkClassName} to="/messages"><i><Icon icon="chat" size={24} /></i>{numUnread && <span className={badgeClassName}>{numUnread}</span> || null}{strings.Messages()}</Link>
      <Link className={linkClassName} to="/manage"><i><Icon icon="manageAccounts" size={24} /></i>{strings.Manage()}</Link>
    </div>
  );
};
